import React from 'react';
import { IListProps } from './List.component';

type ListContext = {
  variant: NonNullable<IListProps['variant']>;
  size: NonNullable<IListProps['size']>;
};

const defaultContext: ListContext = {
  variant: 'default',
  size: 'medium',
};

const Context = React.createContext<ListContext>(defaultContext);

export const useListContext = () => {
  return React.useContext(Context);
};

export const ListProvider = ({ children, value }) => {
  return <Context.Provider value={{ ...defaultContext, ...value }}>{children}</Context.Provider>;
};
